export default "__VITE_ASSET__8b87082a__"